/**
 * Review Platform Constants
 */

// Platform Types - Frozen object
export const REVIEW_PLATFORM_TYPES = Object.freeze({
  GOOGLE: "GOOGLE",
  FACEBOOK: "FACEBOOK",
  YELP: "YELP",
  DEALER_RATER: "DEALER_RATER",
  CUSTOM_SITE: "CUSTOM_SITE",
});

// Platform Display Names
export const REVIEW_PLATFORM_LABELS = Object.freeze({
  [REVIEW_PLATFORM_TYPES.GOOGLE]: "Google",
  [REVIEW_PLATFORM_TYPES.FACEBOOK]: "Facebook",
  [REVIEW_PLATFORM_TYPES.YELP]: "Yelp",
  [REVIEW_PLATFORM_TYPES.DEALER_RATER]: "Dealer Rater",
  [REVIEW_PLATFORM_TYPES.CUSTOM_SITE]: "Custom Site",
});
